<template>
  <div class="div-background py-5">
    <b-container class="bv-example-row">
      <b-alert
        :show="messageObject.success.count"
        dismissible
        @dismissed="messageObject.success.count = 0"
        @dismiss-count-down="successCountChanged"
        >{{ messageObject.success.content }}
      </b-alert>
      <b-alert
        :show="messageObject.warning.count"
        variant="danger"
        dismissible
        @dismissed="messageObject.warning.count = 0"
        @dismiss-count-down="warningCountChanged"
        >{{ messageObject.warning.content }}
      </b-alert>
      <!-- <b-row align-v="center" align-h="center" class="height100">
        <b-col sm="10" md="8" lg="6" xl="5">
          <b-form>
            <b-form-group>
              <b-form-input v-model="account.userid" type="text" size="lg" required placeholder="帳號"></b-form-input>
            </b-form-group>
            <b-form-group>
              <b-form-input v-model="account.passwd" type="password" size="lg" required placeholder="密碼"></b-form-input>
            </b-form-group>
            <b-form-group>
              <b-form-input v-model="account.imgobj.value" type="text" size="lg" required placeholder="驗證碼"></b-form-input>
            </b-form-group>
            <b-form-group>
              <img v-bind:src="account.imgobj.url"/>
            </b-form-group>
          </b-form>
          <b-row align-h="between" class="mb-4">
            <b-col md="auto">
              <b-form-checkbox
                v-model="account.ifremember"
                value=true
                unchecked-value=false
                >記住我的帳號</b-form-checkbox>
            </b-col>
            <b-col md="auto">
              <span v-b-modal.modal-forgetpassword>忘記密碼</span>
              <b-modal
                id="modal-forgetpassword"
                ref="forgetpasswordmodal"
                title="忘記密碼"
                @show="resetForgetPasswordModal"
                @hidden="resetForgetPasswordModal"
                @ok="handleForgetPasswordOk"
              >
                <form ref="form" @submit.stop.prevent="handleSubmit">
                  <b-form-group
                    label="請輸入您的Email"
                    label-for="email-input"
                    invalid-feedback="Email格式錯誤"
                    valid-feedback="格式正確"
                    :state="account.state"
                  >
                  <b-input-group size="lg">
                  <b-input-group-prepend is-text>
                    <b-icon icon="envelope"></b-icon>
                  </b-input-group-prepend>
                    <b-form-input
                      id="email-input"
                      v-model="account.email"
                      :state="account.state"
                      required
                    ></b-form-input>
                  </b-input-group>
                  </b-form-group>
                </form>
              </b-modal>
            </b-col>
          </b-row>
          <b-button block @click="sumbitEvent()" size="lg" variant="primary">登入</b-button>
        </b-col>
      </b-row> -->
      <b-card-group deck>
        <b-card title="登入">
          <b-button
            block
            size="lg"
            variant="success"
            style="padding-bottom: 0;padding-top: 0; margin-bottom:10px; margin-top:10px;"
            @click="Auth()"
            ><img src="../../public/imgs/icons8-line.svg" ><span>Line Login</span> </b-button
          >
          <b-form>
            <b-form-group>
              <b-form-input
                v-model="account.userid"
                type="text"
                size="lg"
                required
                placeholder="電子郵件"
              ></b-form-input>
            </b-form-group>
            <b-form-group>
              <b-form-input
                v-model="account.passwd"
                type="password"
                size="lg"
                required
                placeholder="密碼"
              ></b-form-input>
            </b-form-group>
            <b-form-group>
              <b-form-input
                v-model="account.imgobj.value"
                type="text"
                size="lg"
                required
                placeholder="驗證碼"
              ></b-form-input>
            </b-form-group>
          </b-form>
          <b-row style="margin-bottom: 10px; margin-left: 2px">
            <div><img v-bind:src="account.imgobj.url" /></div>
            <b-col align-self="end"><b-button style="width: 80px" block @click="getImageCode()"><b-icon icon="arrow-repeat"></b-icon>重整</b-button></b-col>
          </b-row>
          <b-row align-h="between" class="mb-4">
            <!-- <b-col md="auto"  原本就隱藏的部分>
              <b-form-checkbox
                v-model="rememberaccount"
                value="true"
                unchecked-value="false"
                >記住我的帳號</b-form-checkbox
              >
            </b-col> -->
            <b-col md="auto">
              <b-button variant="warning" style="color: white" v-b-modal.modal-forgetpassword>忘記密碼</b-button>
              <b-modal
                id="modal-forgetpassword"
                ref="forgetpasswordmodal"
                title="忘記密碼"
                @show="resetForgetPasswordModal"
                @hidden="resetForgetPasswordModal"
                @ok="handleForgetPasswordOk"
              >
                <form ref="form" @submit.stop.prevent="handleSubmit">
                  <b-form-group
                    label="請輸入您的Email"
                    label-for="email-input"
                    invalid-feedback="Email格式錯誤"
                    valid-feedback="格式正確"
                    :state="account.state"
                  >
                    <b-input-group size="lg">
                      <b-input-group-prepend is-text>
                        <b-icon icon="envelope"></b-icon>
                      </b-input-group-prepend>
                      <b-form-input
                        id="email-input"
                        v-model="account.email"
                        :state="account.state"
                        required
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </form>
              </b-modal>
            </b-col>
            <b-col>
              <!-- 原本就隱藏的部分 <span v-b-modal.modal-resendemail>重新發送驗證信</span> -->
              <b-modal
                id="modal-resendemail"
                ref="resendemailmodal"
                title="重新發送驗證信"
                @show="resendEmailModal"
                @hidden="resendEmailModal"
                @ok="handleresendEmailOk"
              >
                <form ref="form" @submit.stop.prevent="handleSubmit">
                  <b-form-group
                    label="請輸入您的Email"
                    label-for="email-input"
                    invalid-feedback="Email格式錯誤"
                    valid-feedback="格式正確"
                    :state="account.state"
                  >
                    <b-input-group size="lg">
                      <b-input-group-prepend is-text>
                        <b-icon icon="envelope"></b-icon>
                      </b-input-group-prepend>
                      <b-form-input
                        id="email-input"
                        v-model="account.email"
                        :state="account.state"
                        required
                      ></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </form>
              </b-modal>
            </b-col>
          </b-row>
          <!-- <b-button
            block
            @click="sumbitEvent()"
            size="lg"
            class="btn btn-success"
            >登入</b-button
          > -->
          <!--新登入+LineLogin-->
          <b-button
            block
            @click="sumbitEvent()"
            size="lg"
            variant="info"
            >登入</b-button
          >
          
        </b-card>
        <!-- <b-card>
          <div style=" background-color: dimgray; height: 25rem; margin-top: 2rem; padding: 2rem;">
            <div style="text-align: center;">
              <h1 style="color: red; margin-left:1rem;">系統維護公告!!</h1>
            </div>
            <hr>
            <div style="text-align: center;">
              <h2 style="color:black;">為了提供更好的使用者服務，於XX/XX XX:00進行系統維護，</h2>
              <h2 style="color:black;">並於XX前完成維護，造成您的不便，請多見諒!</h2>
            </div>
          </div>
        </b-card> -->
        <b-card title="註冊">
          <b-button
            block
            size="lg"
            variant="success"
            style="padding-bottom: 0;padding-top: 0; margin-bottom:10px; margin-top:10px;"
            @click="Auth()"
            ><img src="../../public/imgs/icons8-line.svg" ><span>Line Login</span> </b-button
          >
          <b-form-group
            label-for="register-name"
            label-cols-sm="3"
            label-align-sm="right"
            label-class="required"
          >
            <template v-slot:label>
              <span class="text-danger">*</span> 姓名
            </template>
            <b-form-input
              v-model="registerObject.username.value"
              placeholder="請輸入姓名"
              :state="registerObject.username.state"
              aria-describedby="register-name-feedback"
              id="register-name"
            ></b-form-input>
            <b-form-invalid-feedback id="register-name-feedback">
              {{ registerObject.username.message }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group
            label="電子郵件"
            label-for="register-email"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <template v-slot:label>
              <span class="text-danger">*</span> 電子郵件
            </template>
            <b-form-input
              v-model="registerObject.email.value"
              id="register-email"
              placeholder="請輸入Email"
              :state="registerObject.email.state"
              aria-describedby="register-email-feedback"
            >
            </b-form-input>
            <b-form-invalid-feedback id="register-email-feedback">
              {{ registerObject.email.message }}
            </b-form-invalid-feedback>
          </b-form-group>

          <!-- <b-form-group
            label-for="register-group"
            label-cols-sm="3"
            label-align-sm="right"
            >
            <template v-slot:label>
              <span class="text-danger">*</span> 群組
            </template>
            <b-form-select
              id="register-group"
              v-model="registerObject.group.value"
              :options="grouplist"
              :state="registerObject.group.state"
              aria-describedby="register-group-feedback"
            >
            </b-form-select>
            <b-form-invalid-feedback id="register-group-feedback">
              {{ registerObject.group.message }}
            </b-form-invalid-feedback>
          </b-form-group> -->

          <!-- <b-form-group
            label="職稱"
            label-for="register-role"
            label-cols-sm="3"
            label-align-sm="right"
          >
            <b-form-input
              v-model="registerObject.role.value"
              placeholder="請輸入職稱"
              id="register-role"
            >
            </b-form-input>
          </b-form-group> -->

          <!-- <b-form-group
            label-for="register-phone"
            label-cols-sm="3"
            label-align-sm="right"
            description="手機號碼請輸入10碼，例：0912345678
          電話號碼如有分機請加「#」，例：051234567#1234"
          >
            <template v-slot:label>
              <span class="text-danger">*</span> 電話/手機
            </template>
            <b-form-input
              v-model="registerObject.phone.value"
              :state="registerObject.phone.state"
              placeholder="請輸入電話號碼"
              aria-describedby="register-phone-feedback"
              id="register-phone"
            >
            </b-form-input>
            <b-form-invalid-feedback id="register-phone-feedback">
              {{ registerObject.phone.message }}
            </b-form-invalid-feedback>
          </b-form-group> -->

          <b-form-group
            label-for="register-password"
            label-cols-sm="3"
            label-align-sm="right"
            description="英文字母與數字組合，長度8個字元以上不含空白字元"
          >
            <template v-slot:label>
              <span class="text-danger">*</span> 密碼
            </template>
            <b-form-input
              v-model="registerObject.userpwd.first.value"
              :state="registerObject.userpwd.first.state"
              type="password"
              aria-describedby="register-firstpassword-feedback"
              id="register-password"
            >
            </b-form-input>
            <b-form-invalid-feedback id="register-firstpassword-feedback">
              {{ registerObject.userpwd.first.message }}
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group
            label-for="register-pwdconfirm"
            label-cols-sm="3"
            label-align-sm="right"
            description="確認密碼"
          >
            <template v-slot:label>
              <span class="text-danger">*</span> 確認密碼
            </template>
            <b-form-input
              v-model="registerObject.userpwd.second.value"
              :state="registerObject.userpwd.second.state"
              type="password"
              aria-describedby="register-pwdconfirm-feedback"
              id="register-pwdconfirm"
            >
            </b-form-input>
            <b-form-invalid-feedback id="register-pwdconfirm-feedback">
              {{ registerObject.userpwd.second.message }}
            </b-form-invalid-feedback>
          </b-form-group>
          <!-- <b-form-group
          label="訂閱"
          label-for="register-subscrible"
          label-cols-sm="3"
          label-align-sm="right"
          description="訂閱農作物交易行情及氣象預警通知"
        >
        <b-form-checkbox
          id="register-subscrible"
          v-model="registerObject.subscribile.value"
          name="check-button" switch
          >
          </b-form-checkbox>
        </b-form-group> -->
          <b-button
            @click="registerprocess"
            block
            size="lg"
            class="btn btn-register"
            >註冊</b-button
          >
        </b-card>
      </b-card-group>
    </b-container>
  </div>
</template>

<script>
import _ from "lodash";
import router from "@/router"

export default {
  name: "Login",
  data() {
    return {
      rememberaccount: false,
      ifregisterprocess: false,
      grouplist: [],
      isSucessMsgShow: 0,
      errors: [],
      imageurl: String,
      hiddenCode: String,
      imageObj: String,
      email: "",
      account: {
        userid: null,
        passwd: null,
        state: null,
        email: null,
        imgobj: {
          url: null,
          hiddenCode: null,
          value: null,
        },
      },
      registerObject: {
        username: {
          value: null,
          state: null,
          message: "必填欄位",
        },
        userpwd: {
          first: {
            value: null,
            state: null,
            message: "必填欄位",
          },
          second: {
            value: null,
            state: null,
            message: "必填欄位",
          },
        },
        email: {
          value: null,
          state: null,
          message: "必填欄位",
        },
        group: {
          value: null,
          state: null,
          message: "必填欄位",
        },
        phone: {
          value: null,
          state: null,
          message: "必填欄位",
        },
        role: {
          value: null,
          state: null,
        },
        subscribile: {
          value: false,
          state: null,
        },
      },
      messageObject: {
        warning: {
          //show: false,
          content: null,
          count: 0,
        },
        success: {
          //show: false,
          content: null,
          count: 0,
        },
        dismissSecs: 3,
      },
      emailState: null,
      wanringAlerCount: 0,
      wanringMsg: "",
      successMsg: "",
      accountValue: "",
      pwdValue: "",
      imgCodeValue: "",
      dismissSecs: 3,
      apiImageCode: (data) =>
        this.userRequest.post("API/Default/GetImageCode", data),
      apiLogin: (data) => this.userRequest.post("API/Default/Login", data),
      apiForgetPassword: (data) =>
        this.userRequest.post("API/Default/LastPass", data),
      // apiPasswordReset: (data) => this.userRequest.post("API/Default/LastPassReset", data),
      apiAccountGroupSignList: (data) =>
        this.userRequest.post("/API/Default/AccountGroupSignList", data),
      apiInsertAccount: (data) =>
        this.userRequest.post("/API/Default/InsertAccount", data),
      apiResendCertification: (data) =>
        this.userRequest.post("/API/Default/ResendCertification", data),
    };
  },
  created() {
    if (localStorage.getItem("chiayiaccount")) {
      this.account.userid = localStorage.getItem("chiayiaccount");
      this.rememberaccount = true;
    }
  },
  mounted() {
    this.FunctionToken(this.getImageCode, {});
    this.FunctionToken(this.getAccountGroupSignList, {});
  },
  watch: {
    email: function(newValue) {
      this.checkFormValidity(newValue)
    },
    rememberaccount: function() {
      if (this.rememberaccount == "false") {
        localStorage.removeItem("chiayiaccount");
      }
    },
    "registerObject.username.value"(val) {
      this.registerObject.username.state =
        this.IsNull(val) == "" ? false : true;
    },
    // "registerObject.group.value"(val) {
    //   this.registerObject.group.state = this.IsNull(val) == "" ? false : true;
    // },
    "registerObject.email.value"(val) {
      if (this.IsNull(val) == "") {
        this.registerObject.email.state = false;
        this.registerObject.email.message = "必填欄位";
      } else if (!this.validEmail(val)) {
        this.registerObject.email.state = false;
        this.registerObject.email.message = "Email格式錯誤";
      } else {
        this.registerObject.email.state = true;
      }
    },
    "registerObject.phone.value"(val) {
      this.registerObject.phone.state = this.IsNull(val) == "" ? false : true;
    },
    "registerObject.userpwd.first.value"(val) {
      if (val.length == 0) {
        this.registerObject.userpwd.first.message = "必填欄位";
        this.registerObject.userpwd.first.state = false;
      } else if (val.length < 8) {
        this.registerObject.userpwd.first.message = "密碼至少8個字元";
        this.registerObject.userpwd.first.state = false;
      } else {
        let numasc = 0;
        let charasc = 0;
        for (let i = 0; i < val.length; i++) {
          let asciiNumber = val.substr(i, 1).charCodeAt();
          if (asciiNumber >= 48 && asciiNumber <= 57) {
            numasc = 1;
          }
          if (
            (asciiNumber >= 65 && asciiNumber <= 90) ||
            (asciiNumber >= 97 && asciiNumber <= 122)
          ) {
            charasc = 1;
          }
        }
        if (numasc == 0) {
          this.registerObject.userpwd.first.message = "密碼必須含有數字";
          this.registerObject.userpwd.first.state = false;
        } else if (charasc == 0) {
          this.registerObject.userpwd.first.message = "密碼必須含有字母";
          this.registerObject.userpwd.first.state = false;
        } else {
          this.registerObject.userpwd.first.state = true;
        }
      }
    },
    "registerObject.userpwd.second.value"(val) {
      if (val.length == 0) {
        this.registerObject.userpwd.second.message = "必填欄位";
        this.registerObject.userpwd.second.state = false;
      } else if (val != this.registerObject.userpwd.first.value) {
        this.registerObject.userpwd.second.message = "與第一次密碼不對稱";
        this.registerObject.userpwd.second.state = false;
      } else {
        this.registerObject.userpwd.second.state = true;
      }
    },
  },
  methods: {
    // <summary>
    // API Methods
    // </summary>
    // Start //
    async Auth(){
      let data = await this.userRequest.post("/API/Line/GetLineOption",{state:"goLine"});
      let jsondata = JSON.parse(data.data);
      if(jsondata.Status){
          let res = JSON.parse(jsondata.Data);
          //console.log(res);
          let URL = 'https://access.line.me/oauth2/v2.1/authorize?';
          URL += 'response_type=code';
          
          //channel id
          URL += '&client_id='+res.channel_id; 

          // 與Line Developer Channel設定的一樣就好，驗證完就會經過瀏覽器轉址回來
          URL += '&redirect_uri='+res.authorize_uri;

          // 狀態碼是會從client呼叫端帶到驗證端，再從驗證端帶回
          // 因此應該可以作為一個亂數卡控確保是自已丟出去的交易碼
          URL += '&state='+res.state;   
          
          //要求存取的範圍
          URL += '&scope=openid%20profile%20email';
          
          window.location.href = URL;
          return window.location.href;
      }
    },
    verifyLoginProcess(data) {
      this.apiLogin(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            let jsondata = JSON.parse(json.Data);
            //console.log("Login jsondata",jsondata);
            if (this.rememberaccount == "true") {
              localStorage.setItem("chiayiaccount", this.account.userid);
            }
            sessionStorage.setItem("TokenID", jsondata.account);
            sessionStorage.setItem("username", this.account.userid);
            if(jsondata.AC_GETGIFT != null) sessionStorage.setItem("getGift", jsondata.AC_GETGIFT);
            if(jsondata.AC_GOOGLEFROM =="true") sessionStorage.setItem("GoogleFrom",true);
            
            this.$parent.refresh();
            //登入成功轉跳
            if(jsondata.ForceChangePassword){
              console.log("ForceChangePassword",jsondata.ForceChangePassword);
              sessionStorage.setItem("ForceChangePassword",true);
              //如果登入後需要強制更改密碼，則將頁面轉跳至更改密碼頁面
              router.push({ path: "/changepassword" });
            } 
            //如果已經做過第一次訂閱，則將頁面轉跳至我的專區
            else if(jsondata.AC_GROUPID == '1'){
              router.push({ path: "/SupervisorArea" });
            }
            else if(jsondata.AC_FIRST_SUBSCRIPTION == 1){
              router.push({ path: "/myprefecture" });
            }else{
              router.push({ path: "/subscription" });
            }
            
          } else {
            console.log("Login error",json.Message);
            this.getImageCode();
            this.account.imgobj.value = "";
            if(json.Message == "您所輸入的帳號或密碼錯誤，請重新登入") {
              this.waningPopUp(json.Data);
              return;
            }
            this.waningPopUp(json.Message);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    setForgetPasswordEmail(data) {
      this.apiForgetPassword(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.$nextTick(() => {
              this.$bvModal.hide("modal-forgetpassword");
              this.suceessPopUp("已傳送驗證信到該信箱");
            });
          } else {
            this.$bvModal.hide("modal-forgetpassword");
            this.waningPopUp("發生錯誤");
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getImageCode(data) {
      this.apiImageCode(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          // this.imageObj = json.Data
          let subObj = JSON.parse(json.Data);
          this.account.imgobj.url = subObj.Image;
          this.account.imgobj.hiddenCode = subObj.Code;
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    getAccountGroupSignList(data) {
      this.apiAccountGroupSignList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          // this.imageObj = json.Data
          this.grouplist = this.addDescription(JSON.parse(json.Data));
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    InsertAccount(data) {
      this.apiInsertAccount(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.suceessPopUp("已傳送驗證信到該信箱");
            // if (data.AC_GROUP_ID == "4") {
            //   this.suceessPopUp("已傳送驗證信到該信箱");
            // } else {
            //   this.suceessPopUp("已傳送訊息給管理員，請等待管理員驗證");
            // }
          } else {
            this.waningPopUp(json.Data);
          }
          this.ifregisterprocess = false;
        })
        .catch((err) => {
          console.warn(err);
          this.waningPopUp(err);
          this.ifregisterprocess = false;
        });
    },
    setResendCertification(data) {
      this.apiResendCertification(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          if (json.Status) {
            this.$nextTick(() => {
              this.$bvModal.hide("modal-resendemail");
              this.suceessPopUp("已傳送驗證信到該信箱");
            });
          } else {
            this.$bvModal.hide("modal-resendemail");
            this.waningPopUp(json.Data);
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    // END //
    // delayprocess(value, delay, fn)
    // {
    //   if(value==0)
    //   {
    //     this.throttled(delay, fn)
    //   }
    //   else if(value==1)
    //   {
    //     this.debounced(delay, fn)
    //   }
    // },
    registerprocess: _.debounce(function() {
      if (
        this.registerObject.username.state == false ||
        this.registerObject.username.state == null ||
        this.registerObject.email.state == false ||
        this.registerObject.email.state == null ||
        // this.registerObject.phone.state == false ||
        // this.registerObject.phone.state == null ||
        this.registerObject.userpwd.first.state == false ||
        this.registerObject.userpwd.first.state == null ||
        this.registerObject.userpwd.second.state == false ||
        this.registerObject.userpwd.second.state == null
      ) {
        this.waningPopUp("請將必填欄位填寫完畢或請符合資料格式");
      } else {
        this.ifregisterprocess = true;
        let obj = {
          AC_USERID: this.registerObject.email.value,
          AC_USERNAME: this.registerObject.username.value,
          AC_GROUP_ID: this.registerObject.group.value,
          AC_TITLE: this.registerObject.role.value,
          //AC_TEL: this.registerObject.phone.value,
          AC_PWD: this.registerObject.userpwd.first.value,
          // "AC_NOTIFY": this.registerObject.subscribile.value.toString()
        };
        this.FunctionToken(this.InsertAccount, obj);
      }
    }, 500),
    addDescription(value) {
      let list = [];
      for (let i in value) {
        if (i != 0) {
          let item = {
            text:
              value[i] == "農民" ? value[i] : value[i].concat(" (需經審核)"),
            value: i,
          };
          if (value[i] == "農民") list.unshift(item);
          else list.push(item);
        }
      }
      return list;
    },
    validEmail(email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    sumbitEvent: _.throttle(function() {
      let loginData = {
        Id: this.account.userid,
        DecryptionPass: this.account.passwd,
        CodePass: this.account.imgobj.value,
        DecryptionCodePass: this.account.imgobj.hiddenCode,
      };
      this.FunctionToken(this.verifyLoginProcess, loginData);
    }, 1000),
    checkFormValidity(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      this.account.emailState = re.test(email);
    },
    resetForgetPasswordModal() {
      this.account.email = null;
      this.account.emailState = null;
      this.$bvModal.hide("modal-forgetpassword");
    },
    handleForgetPasswordOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    handleSubmit() {
      // Exit when the form isn't valid
      // Hide the modal manually
      let item = {
        AC_USERID: this.account.email,
      };
      this.FunctionToken(this.setForgetPasswordEmail, item);
      //alert("Email輸入成功")
    },
    waningPopUp(msg) {
      this.messageObject.warning.count = this.dismissSecs;
      this.messageObject.warning.content = msg;
    },
    suceessPopUp(msg) {
      this.messageObject.success.count = this.dismissSecs;
      this.messageObject.success.content = msg;
    },
    warningCountChanged(count) {
      this.messageObject.warning.count = count;
    },
    successCountChanged(count) {
      this.messageObject.success.count = count;
    },
    resendEmailModal() {
      this.account.email = null;
      this.account.emailState = null;
      this.$bvModal.hide("modal-resendemail");
    },
    handleresendEmailOk(bvModalEvt) {
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleRendEmail();
    },
    handleRendEmail() {
      let item = {
        AC_USERID: this.account.email,
      };
      this.FunctionToken(this.setResendCertification, item);
    },
  },
};
</script>
<style lang="scss" scoped>
.required:before {
  content: "*";
  color: red;
}

.refreshgroup {
  display: inline-flex;
}

#refresbutton {
  height: 40px;
  display: inline-flex;
}
.btn-register{
  background-color: rgba(22, 22, 243, 0.776);
  border-color: rgba(22, 22, 243, 0.776);
}
.btn-register:hover {
  background-color: rgba(18, 18, 166, 0.8);
  border-color: rgba(18, 18, 166, 0.8);
}
// .custom-control-label::after {
//   color: #fff !important;
//   background-color: #28a745 !important;
//   border-color: #28a745 !important;
// }

</style>
